import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Room} from '../shared/Room';
import {MiniBookAdminService} from './mini-book-admin.service';

@Injectable()
export class RoomPublicService {

  constructor(private http: HttpClient, private adminService: MiniBookAdminService) { }

  getRooms(): Observable<Room[]> {
    return this.http.get<any[]>(`${environment.url}${this.adminService.tenant}/rooms`).pipe(
      map<any[], Room[]>(data => data.map(value => Room.createFromJson(value)))
    );
  }

  getRoom(id: number): Observable<Room> {
    return this.http.get<any>(`${environment.url}${this.adminService.tenant}/rooms/${id}`).pipe(
      map<any, Room>(data => Room.createFromJson(data))
    );
  }

}
